import { jsx as o, jsxs as h, Fragment as W } from "react/jsx-runtime";
import { signOut as ye, fetchAuthSession as ze, fetchUserAttributes as lt, getCurrentUser as dt, signInWithRedirect as $e, confirmSignIn as Fe, signIn as ut, confirmResetPassword as ct, resetPassword as ht } from "aws-amplify/auth";
import { createContext as He, useState as u, useEffect as be, useContext as Ge, lazy as wt, Suspense as pt } from "react";
import { useRouterState as gt } from "@tanstack/react-router";
import { Stack as S, AssetWatchLogo as ge, Headline as xe, Text as U, Button as T, Tile as ft, Group as Ce, Title as Be, Label as mt, Icon as Me, Input as ne, Checkbox as Pt, toast as yt, BlockingActionOverlay as bt, Alert as je, Divider as Ct } from "@assetwatch/ui";
import { LDProvider as St, useLDClient as vt } from "launchdarkly-react-client-sdk";
import { cognitoUserPoolsTokenProvider as It } from "aws-amplify/auth/cognito";
import { CookieStorage as Et } from "aws-amplify/utils";
import { post as Rt } from "aws-amplify/api";
import { useMutation as Qe } from "@tanstack/react-query";
function Lt(e) {
  return e.startsWith("http://") || e.startsWith("https://") ? e : `https://${e}`;
}
async function xt(e) {
  try {
    await ye({ global: !0 });
  } finally {
    if (typeof window > "u" || !e?.clientId || !e.domain || !e.redirectUri)
      return;
    const r = new URL(
      "/logout",
      Lt(e.domain)
    );
    r.searchParams.set("client_id", e.clientId), r.searchParams.set("logout_uri", e.redirectUri), window.location.assign(r.toString());
  }
}
const Ke = He(void 0);
function Er({
  children: e,
  fetchUserData: r,
  validateAuthenticatedUser: t,
  signOutRedirect: s
}) {
  const [n, a] = u(!1), [i, d] = u(!0), [w, g] = u(null), [l, p] = u(null);
  be(() => {
    c();
  }, [r, t]);
  async function c() {
    try {
      const m = await ze();
      if (m.tokens) {
        const C = await lt(), Q = m.tokens.accessToken?.payload?.["cognito:groups"], K = Array.isArray(Q) ? Q.filter((_) => typeof _ == "string") : [], x = await dt(), z = m.tokens.idToken?.payload?.identities, V = {
          email: C.email || "",
          role: C["custom:role"] || "",
          sub: C.sub || "",
          cognitoGroups: K,
          username: x.username,
          name: typeof m.tokens.idToken?.payload?.name == "string" ? m.tokens.idToken.payload.name : void 0,
          isSsoUser: Array.isArray(z) && z.length > 0
        }, M = r ? await r({ session: m, baseUser: V }) : {}, A = {
          ...V,
          ...M,
          cognitoGroups: M.cognitoGroups ?? V.cognitoGroups
        };
        if (t) {
          const _ = await t({
            session: m,
            user: A
          });
          if (!_.ok) {
            await ye(), p(_.message), a(!1), g(null);
            return;
          }
        }
        p(null), g(A), a(!0);
      } else
        a(!1), g(null);
    } catch {
      a(!1), g(null);
    } finally {
      d(!1);
    }
  }
  async function b() {
    try {
      p(null), await $e();
    } catch (m) {
      if (m instanceof Error && m.name === "UserAlreadyAuthenticatedException")
        await c();
      else
        throw m;
    }
  }
  async function N() {
    await xt(s), await c();
  }
  const E = {
    isAuthenticated: n,
    isLoading: i,
    validationError: l,
    refreshAuth: c,
    user: w,
    signIn: b,
    signOut: N
  };
  return /* @__PURE__ */ o(Ke.Provider, { value: E, children: e });
}
function Ye() {
  const e = Ge(Ke);
  if (e === void 0)
    throw new Error("useAuth must be used within an AuthProvider");
  return e;
}
const Tt = wt(
  () => import("./CelebrationGraphic-DKEoWOy6.js").then((e) => ({
    default: e.CelebrationGraphic
  }))
);
function Nt({
  isLoading: e,
  messages: r,
  onStartMonitoring: t
}) {
  const s = r.actions.startMonitoring ?? "Start monitoring";
  return /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ h(S, { align: "center", gap: 16, children: [
      /* @__PURE__ */ o(ge, { "aria-hidden": !0, size: "display", tone: "default" }),
      /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: r.headings.accountCreatedTitle }),
      /* @__PURE__ */ o("div", { className: "w-full max-w-[334px]", children: /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: r.headings.accountCreatedDescription }) })
    ] }),
    /* @__PURE__ */ h(S, { align: "center", gap: 40, children: [
      /* @__PURE__ */ o(pt, { fallback: null, children: /* @__PURE__ */ o(Tt, { size: "xl" }) }),
      /* @__PURE__ */ o(
        T,
        {
          "data-testid": "start-monitoring-button",
          fullWidth: !0,
          loading: e,
          loadingText: r.loading.redirecting,
          type: "button",
          onClick: t,
          children: s
        }
      )
    ] })
  ] });
}
const Se = {
  digitRequirement: "contain at least one digit",
  lowercaseRequirement: "contain at least one lowercase letter",
  uppercaseRequirement: "contain at least one uppercase letter",
  specialCharacterRequirement: "contain at least one special character",
  lengthRequirement: "be at least 10 characters in length, but not more than 32",
  previousPasswordRequirement: "not one of your previous 12 passwords (verified after submission)",
  passwordStrength: {
    weak: "Weak",
    fair: "Fair",
    strong: "Strong"
  }
};
function kt(e) {
  return [
    e.hasLowercase,
    e.hasUppercase,
    e.hasNumber,
    e.hasSpecialCharacter,
    e.hasSufficientLength
  ];
}
function $t({
  isPassedPasswordHistory: e,
  requirements: r,
  showPreviousPasswordRequirement: t
}) {
  const s = kt(r), n = t ? [...s, e === !0] : s;
  return n.some(Boolean) ? n.every(Boolean) ? "strong" : r.hasLowercase && r.hasUppercase && r.hasSufficientLength ? "fair" : "weak" : null;
}
function Mt(e) {
  return e === "weak" ? "negative" : e === "fair" ? "warning" : "positive";
}
function At(e) {
  return e === void 0 ? {
    icon: "warning",
    tone: "warning"
  } : e ? {
    icon: "circle-check",
    tone: "positive"
  } : {
    icon: "circle-xmark-solid",
    tone: "negative"
  };
}
function pe({
  children: e,
  isSatisfied: r,
  variant: t = "list"
}) {
  if (t === "panel")
    return /* @__PURE__ */ h(Ce, { align: "center", gap: 8, children: [
      /* @__PURE__ */ o(
        Me,
        {
          "aria-hidden": !0,
          name: "circle-check-regular",
          size: "sm",
          tone: r ? "positive" : "secondary"
        }
      ),
      /* @__PURE__ */ o(U, { as: "span", size: "sm", children: e })
    ] });
  const { icon: s, tone: n } = At(r);
  return /* @__PURE__ */ h(Ce, { align: "start", gap: 8, children: [
    /* @__PURE__ */ o(Me, { "aria-hidden": !0, name: s, size: "sm", tone: n }),
    /* @__PURE__ */ o(U, { size: "sm", tone: "subtext", children: e })
  ] });
}
function Je({
  requirements: e,
  isPassedPasswordHistory: r,
  labels: t = Se,
  showPreviousPasswordRequirement: s = !0,
  title: n,
  variant: a = "list"
}) {
  const i = a === "panel" ? $t({
    isPassedPasswordHistory: r,
    requirements: e,
    showPreviousPasswordRequirement: s
  }) : null, d = i ? t.passwordStrength?.[i] ?? Se.passwordStrength?.[i] : void 0, w = /* @__PURE__ */ h(S, { gap: a === "panel" ? 10 : 8, children: [
    /* @__PURE__ */ o(pe, { isSatisfied: e.hasLowercase, variant: a, children: t.lowercaseRequirement }),
    /* @__PURE__ */ o(pe, { isSatisfied: e.hasUppercase, variant: a, children: t.uppercaseRequirement }),
    /* @__PURE__ */ o(pe, { isSatisfied: e.hasNumber, variant: a, children: t.digitRequirement }),
    /* @__PURE__ */ o(
      pe,
      {
        isSatisfied: e.hasSpecialCharacter,
        variant: a,
        children: t.specialCharacterRequirement
      }
    ),
    /* @__PURE__ */ o(
      pe,
      {
        isSatisfied: e.hasSufficientLength,
        variant: a,
        children: t.lengthRequirement
      }
    ),
    s ? /* @__PURE__ */ o(pe, { isSatisfied: r, variant: a, children: t.previousPasswordRequirement }) : null
  ] });
  return a === "panel" ? /* @__PURE__ */ o(ft, { padding: "dense", radius: "sm", tone: "muted", width: "full", children: /* @__PURE__ */ h(S, { gap: 8, children: [
    n || d ? /* @__PURE__ */ h(Ce, { justify: "between", children: [
      n ? /* @__PURE__ */ o(Be, { as: "span", size: "sm", children: n }) : null,
      i && d ? /* @__PURE__ */ o(mt, { size: "md", tone: Mt(i), children: d }) : null
    ] }) : null,
    w
  ] }) }) : w;
}
function _t({
  authType: e,
  firstSignIn: r,
  isTemporaryPasswordChallenge: t,
  messages: s
}) {
  return /* @__PURE__ */ h(S, { align: "center", gap: 16, children: [
    t ? /* @__PURE__ */ o(ge, { size: "display", "aria-hidden": !0 }) : /* @__PURE__ */ o(ge, { "aria-hidden": !0, size: "stacked", tone: "default" }),
    t ? /* @__PURE__ */ h(W, { children: [
      /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: s.headings.updatePasswordTitle }),
      /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: s.headings.updatePasswordDescription })
    ] }) : (e === "basic" || e === "temporaryPassword") && !r ? /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: s.headings.signInDescription }) : /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: s.headings.signInTitle })
  ] });
}
function Ot({
  authType: e,
  email: r,
  emailError: t,
  isCheckingEmail: s,
  isRememberMeEnabled: n,
  messages: a,
  onCheckEmail: i,
  onEmailChange: d,
  onRememberMeChange: w
}) {
  return e === "mfacode" || e === "basic" || e === "temporaryPassword" ? null : /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ o(
      ne,
      {
        autoFocus: !0,
        "data-testid": "email-input",
        disabled: !!e || s,
        error: t ?? void 0,
        label: a.labels.email,
        onChange: (g) => d(g.currentTarget.value),
        placeholder: a.placeholders.email,
        reserveSubtextSpace: !1,
        type: "email",
        value: r
      }
    ),
    e === "" ? /* @__PURE__ */ h(S, { gap: 40, children: [
      /* @__PURE__ */ o(
        Pt,
        {
          checked: n,
          "data-testid": "remember-me",
          label: a.actions.rememberMe,
          onCheckedChange: (g) => w(!!g),
          size: "sm"
        }
      ),
      /* @__PURE__ */ o(
        T,
        {
          "data-testid": "continue-button",
          fullWidth: !0,
          loading: s,
          loadingText: a.loading.checking,
          disabled: !!t,
          type: "button",
          onClick: i,
          children: a.actions.continue
        }
      )
    ] }) : null
  ] });
}
function Dt({
  canSubmit: e,
  email: r,
  isLoading: t,
  isPasswordVisible: s,
  messages: n,
  onPasswordChange: a,
  onPasswordVisibilityChange: i,
  password: d,
  passwordError: w,
  passwordVisibilityLabel: g
}) {
  return /* @__PURE__ */ h(S, { gap: 40, children: [
    /* @__PURE__ */ h(S, { gap: 16, children: [
      /* @__PURE__ */ h(U, { children: [
        n.copy.temporaryPasswordPrompt,
        /* @__PURE__ */ o("br", {}),
        /* @__PURE__ */ o("strong", { children: r.trim().toLowerCase() })
      ] }),
      /* @__PURE__ */ o(
        Te,
        {
          autoFocus: !0,
          error: w,
          isVisible: s,
          label: n.labels.password,
          onChange: a,
          onVisibilityChange: i,
          reserveSubtextSpace: !1,
          value: d,
          visibilityLabel: g
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "login-button",
        disabled: !e,
        fullWidth: !0,
        loading: t,
        loadingText: n.loading.loggingIn,
        type: "submit",
        children: n.actions.login
      }
    ),
    /* @__PURE__ */ o(U, { align: "center", children: n.copy.temporaryPasswordHelp })
  ] });
}
function Ft({
  canSubmit: e,
  email: r,
  forgotPasswordUrl: t,
  isLoading: s,
  isPasswordVisible: n,
  messages: a,
  onChangeEmail: i,
  onPasswordChange: d,
  onPasswordVisibilityChange: w,
  password: g,
  passwordError: l,
  passwordVisibilityLabel: p
}) {
  return /* @__PURE__ */ h(S, { align: "center", gap: 40, children: [
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "change-email-button",
        icon: "edit-pen",
        size: "sm",
        type: "button",
        variant: "outline",
        onClick: i,
        children: r.trim().toLowerCase()
      }
    ),
    /* @__PURE__ */ h(S, { gap: 4, fullWidth: !0, children: [
      /* @__PURE__ */ o(
        Te,
        {
          autoFocus: !0,
          error: l,
          isVisible: n,
          label: a.labels.password,
          onChange: d,
          onVisibilityChange: w,
          reserveSubtextSpace: !1,
          value: g,
          visibilityLabel: p
        }
      ),
      t ? /* @__PURE__ */ o(S, { align: "end", fullWidth: !0, children: /* @__PURE__ */ o(
        T,
        {
          render: /* @__PURE__ */ o("a", { href: t, children: a.actions.forgotPassword }),
          size: "sm",
          variant: "ghost",
          children: a.actions.forgotPassword
        }
      ) }) : null
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "login-button",
        disabled: !e,
        fullWidth: !0,
        loading: s,
        loadingText: a.loading.loggingIn,
        type: "submit",
        children: a.actions.login
      }
    )
  ] });
}
function qt({
  canSubmit: e,
  confirmPassword: r,
  confirmPasswordVisibilityLabel: t,
  isConfirmPasswordVisible: s,
  isLoading: n,
  isNewPasswordVisible: a,
  isTemporaryPasswordChallenge: i,
  messages: d,
  newPassword: w,
  newPasswordError: g,
  newPasswordVisibilityLabel: l,
  onConfirmPasswordChange: p,
  onConfirmPasswordVisibilityChange: c,
  onNewPasswordChange: b,
  onNewPasswordVisibilityChange: N,
  passedPasswordHistory: E,
  passwordValidation: m
}) {
  const C = i ? d.actions.saveChanges ?? "Save changes" : d.actions.setNewPassword;
  return /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ h(S, { gap: 16, children: [
      i ? null : /* @__PURE__ */ o(U, { tone: "subtext", children: d.copy.newPasswordPrompt }),
      /* @__PURE__ */ o(
        Te,
        {
          dataTestId: "new-password-input",
          error: g,
          isVisible: a,
          label: d.labels.newPassword,
          onChange: b,
          onVisibilityChange: N,
          value: w,
          visibilityLabel: l
        }
      ),
      /* @__PURE__ */ o(
        Je,
        {
          isPassedPasswordHistory: E,
          labels: d.passwordRequirements,
          requirements: m,
          showPreviousPasswordRequirement: !i,
          title: i ? d.copy.passwordRequirementsHeading : void 0,
          variant: i ? "panel" : "list"
        }
      ),
      /* @__PURE__ */ o(
        Te,
        {
          dataTestId: "confirm-password-input",
          error: r.length > 0 && !m.matchesConfirm ? d.copy.confirmPasswordMismatch : null,
          isVisible: s,
          label: d.labels.confirmPassword,
          onChange: p,
          onVisibilityChange: c,
          value: r,
          visibilityLabel: t
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "login-button",
        disabled: !e,
        fullWidth: !0,
        loading: n,
        loadingText: d.loading.updatingPassword,
        type: "submit",
        children: C
      }
    )
  ] });
}
function Ut({
  canSubmit: e,
  isLoading: r,
  messages: t,
  mfaCode: s,
  onMfaCodeChange: n
}) {
  return /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ h(S, { gap: 16, children: [
      /* @__PURE__ */ h(S, { gap: 8, children: [
        /* @__PURE__ */ o(Be, { as: "h2", size: "lg", children: t.headings.twoFactorTitle }),
        /* @__PURE__ */ o(U, { tone: "subtext", children: t.headings.twoFactorDescription })
      ] }),
      /* @__PURE__ */ o(
        ne,
        {
          autoFocus: !0,
          "data-testid": "mfa-code-input",
          label: t.labels.verificationCode,
          onChange: (a) => n(a.currentTarget.value),
          type: "text",
          value: s
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "submit-mfa",
        disabled: !e,
        fullWidth: !0,
        loading: r,
        loadingText: t.loading.verifying,
        type: "submit",
        children: t.actions.submit
      }
    )
  ] });
}
function Vt({
  messages: e,
  password: r
}) {
  return /* @__PURE__ */ o(
    ne,
    {
      "data-testid": "password-input",
      disabled: !0,
      label: e.labels.password,
      type: "password",
      value: r
    }
  );
}
function Te({
  autoFocus: e,
  dataTestId: r = "password-input",
  error: t,
  isVisible: s,
  label: n,
  onChange: a,
  onVisibilityChange: i,
  reserveSubtextSpace: d = !0,
  value: w,
  visibilityLabel: g
}) {
  return /* @__PURE__ */ o(
    ne,
    {
      autoFocus: e,
      "data-testid": r,
      error: t ?? void 0,
      label: n,
      onChange: (l) => a(l.currentTarget.value),
      reserveSubtextSpace: d,
      trailingAction: {
        icon: s ? "eye-watching" : "eye-slash-regular",
        "aria-label": g,
        "aria-pressed": s,
        onClick: i
      },
      type: s ? "text" : "password",
      value: w
    }
  );
}
const j = {
  accessibility: {
    assetWatchLogoAriaLabel: "AssetWatch",
    hidePassword: "Hide password",
    showPassword: "Show password"
  },
  headings: {
    signInTitle: "Sign In",
    signInDescription: "Authenticate with your AssetWatch account.",
    updatePasswordTitle: "Let's update your password",
    updatePasswordDescription: "Create a strong password to secure your account",
    accountCreatedTitle: "Account created successfully.",
    accountCreatedDescription: "Your account is ready - start monitoring assets and preventing downtime.",
    twoFactorTitle: "Two-factor authentication",
    twoFactorDescription: "Enter the code from your authenticator app."
  },
  labels: {
    email: "Email",
    password: "Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    verificationCode: "Verification Code"
  },
  placeholders: {
    email: "Email"
  },
  actions: {
    rememberMe: "Remember me",
    continue: "Continue",
    forgotPassword: "Forgot password?",
    reachOutToSupport: "support@assetwatch.com",
    login: "Login",
    loginWithSso: "Login with SSO",
    retry: "Retry",
    saveChanges: "Save changes",
    startMonitoring: "Start monitoring",
    setNewPassword: "Set New Password",
    changeEmail: "Change Email",
    submit: "Submit"
  },
  loading: {
    checking: "Checking",
    updatingPassword: "Updating password",
    loggingIn: "Logging in",
    verifying: "Verifying",
    redirecting: "Redirecting",
    ssoRedirecting: "Signing in with SSO..."
  },
  copy: {
    newPasswordPrompt: "Please enter a new password to replace the temporary one. Your new password must:",
    passwordRequirementsHeading: "Your password must include",
    temporaryPasswordPrompt: "Please enter the temporary password we sent to:",
    temporaryPasswordHelp: "Need a new temporary password? Contact your CSM.",
    confirmPasswordMismatch: "Passwords do not match.",
    supportQuestion: "Questions?"
  },
  status: {
    passwordUpdatedSuccess: "Password updated successfully. Please log in with your new password.",
    temporaryPasswordUpdatedSuccess: "Temporary password updated successfully. Please log in with your new password."
  },
  errors: {
    invalidEmail: "Please enter a valid email.",
    incorrectEmailOrPassword: "Incorrect email or password.",
    accountNotConfirmed: "Your account isn't confirmed. Please check your email for a verification code.",
    passwordResetRequired: "You must reset your password before signing in. Please use 'Forgot password?' to reset.",
    tooManyAttempts: "Too many attempts. Please wait and try again later.",
    network: "Network error. Please check your connection and try again.",
    generic: "Something went wrong. Please try again.",
    passwordHistoryViolation: "This password was used previously. Please choose a new password that you haven't used in your last 12 passwords.",
    invalidPasswordPolicy: "Password does not meet the policy requirements.",
    updatePasswordGeneric: "Error updating password. Please try again.",
    invalidMfaCode: "Invalid MFA code entered. Please try again.",
    identityProviderUndefined: "Identity provider is not defined.",
    unsupportedSignInStep: "Unsupported sign-in step."
  },
  passwordRequirements: Se
}, Re = {
  hasUppercase: !1,
  hasLowercase: !1,
  hasNumber: !1,
  hasSpecialCharacter: !1,
  hasSufficientLength: !1,
  matchesConfirm: !0
}, Ae = "sso_post_login_redirect";
function Ze(e) {
  return typeof e == "string" && e.startsWith("/") && !e.startsWith("//") && !e.startsWith("/\\");
}
function Wt(e) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/.test(
    e
  );
}
function zt(e, r) {
  return {
    hasUppercase: e.toLowerCase() !== e,
    hasLowercase: e.toUpperCase() !== e,
    hasNumber: /[0-9]/.test(e),
    hasSpecialCharacter: /[^a-zA-Z0-9]/.test(e),
    hasSufficientLength: e.length >= 10 && e.length <= 32,
    matchesConfirm: e === r
  };
}
function Ht() {
  const e = sessionStorage.getItem(Ae);
  return sessionStorage.removeItem(Ae), Ze(e) ? e : null;
}
function qe(e) {
  sessionStorage.setItem(Ae, e);
}
function Ue(e, r) {
  const t = e, s = t.name ?? t.code ?? t.__type?.split("#").pop() ?? "", n = String(t.message ?? "");
  return (s === "NotAuthorizedException" || s === "NotAuthorized") && /incorrect username or password/i.test(n) || s === "UserNotFoundException" ? r.errors.incorrectEmailOrPassword : s === "UserNotConfirmedException" ? r.errors.accountNotConfirmed : s === "PasswordResetRequiredException" ? r.errors.passwordResetRequired : s === "LimitExceededException" || s === "TooManyRequestsException" ? r.errors.tooManyAttempts : /Failed to fetch|NetworkError/i.test(n) ? r.errors.network : r.errors.generic;
}
function Gt(e) {
  const r = e, t = r.name ?? r.code ?? r.__type?.split("#").pop() ?? "", s = String(r.message ?? "");
  return t === "UserNotFoundException" || (t === "NotAuthorizedException" || t === "NotAuthorized") && /incorrect username or password/i.test(s);
}
function Ve(e, r) {
  const t = e, s = t.name ?? t.code ?? "", n = String(t.message ?? "");
  return s === "PasswordHistoryPolicyViolationException" ? r.errors.passwordHistoryViolation : s === "InvalidPasswordException" ? r.errors.invalidPasswordPolicy : s === "LimitExceededException" || s === "TooManyRequestsException" ? r.errors.tooManyAttempts : /Failed to fetch|NetworkError/i.test(n) ? r.errors.network : r.errors.updatePasswordGeneric;
}
function Bt(e) {
  const r = e, t = r.name ?? r.code ?? r.__type?.split("#").pop() ?? "";
  return t === "PasswordHistoryPolicyViolationException" || t === "InvalidPasswordException";
}
function jt({
  authenticate: e,
  forgotPasswordHref: r,
  initialEmail: t = "",
  initialStatusMessage: s,
  isAuthenticated: n,
  lookupLoginMethod: a,
  messages: i,
  onNavigate: d,
  passwordUpdated: w = !1,
  redirectTo: g = "/"
}) {
  const l = {
    ...j,
    ...i,
    headings: {
      ...j.headings,
      ...i?.headings
    },
    actions: {
      ...j.actions,
      ...i?.actions
    },
    loading: {
      ...j.loading,
      ...i?.loading
    },
    copy: { ...j.copy, ...i?.copy },
    status: {
      ...j.status,
      ...i?.status
    }
  }, p = Ze(g) ? g : "/", [c, b] = u(""), [N, E] = u(""), [m, C] = u(t), [Q, K] = u(null), [x, z] = u(!1), [V, M] = u(), [A, _] = u(!1), [ae, H] = u(!1), [ue, L] = u(!1), [R, k] = u(!1), [le, re] = u(!1), [$, D] = u(!1), [F, oe] = u(!1), [ce, Y] = u(!1), [se, de] = u(""), [J, O] = u(""), [he, Z] = u(null), [we, G] = u(void 0), [X, B] = u(""), [fe, ee] = u(null), [q, te] = u(
    Re
  ), [I, f] = u(
    s ? "negative" : w ? "positive" : "informative"
  ), [Ee, v] = u(
    s ?? (w ? l.status.passwordUpdatedSuccess : null)
  );
  be(() => {
    const P = localStorage.getItem("rememberMeLogin");
    P && (C(P), oe(!0));
  }, []), be(() => {
    f(
      s ? "negative" : w ? "positive" : "informative"
    ), v(
      s ?? (w ? l.status.passwordUpdatedSuccess : null)
    );
  }, [
    s,
    l.status.passwordUpdatedSuccess,
    w
  ]), be(() => {
    n && d(Ht() ?? p);
  }, [n, d, p]);
  function me() {
    b(""), E(""), z(!1), M(void 0), _(!1), de(""), O(""), Z(null), B(""), ee(null), k(!1), re(!1), D(!1), te(Re), G(void 0), Y(!1), v(null), f("informative");
  }
  function y() {
    return x ? q.hasUppercase && q.hasLowercase && q.hasNumber && q.hasSpecialCharacter && q.hasSufficientLength && q.matchesConfirm : c === "mfacode" ? se.length === 6 : m.trim().length > 0 && X.length > 0;
  }
  async function Pe(P) {
    if (!P) {
      f("negative"), v(l.errors.identityProviderUndefined);
      return;
    }
    M(P), L(!0), Y(!0), v(null), f("informative");
    try {
      await ye(), p !== "/" && qe(p), await $e({
        provider: { custom: P },
        customState: JSON.stringify({ isWebLogin: "true" })
      });
    } catch (ie) {
      Y(!1), f("negative"), v(Ue(ie, l));
    } finally {
      L(!1);
    }
  }
  async function De() {
    const P = m.trim().toLowerCase();
    if (ee(null), !Wt(P)) {
      K(l.errors.invalidEmail);
      return;
    }
    K(null), F ? localStorage.setItem("rememberMeLogin", P) : localStorage.removeItem("rememberMeLogin");
    try {
      H(!0);
      const ie = await a(P);
      ie.authType === "sso" ? await Pe(ie.identityProvider) : b(ie.authType);
    } catch {
      b("basic"), yt.error(l.errors.network, {
        action: {
          label: l.actions.retry ?? "Retry",
          onClick: () => {
            De();
          }
        }
      });
    } finally {
      H(!1);
    }
  }
  async function tt() {
    if (x) {
      if (J !== N)
        return;
      L(!0);
      try {
        Z(null);
        const ie = (await Fe({ challengeResponse: J })).nextStep.signInStep;
        if (ie === "CONFIRM_SIGN_IN_WITH_TOTP_CODE") {
          b("mfacode"), E(""), z(!1), de(""), O(""), B(""), te(Re), G(void 0), v(null), f("informative");
          return;
        }
        if (ie !== "DONE") {
          f("negative"), v(l.errors.unsupportedSignInStep);
          return;
        }
        c === "temporaryPassword" ? (E(""), O(""), G(!0), B(""), te(Re), v(null), _(!0)) : (G(!0), f("positive"), v(
          l.status.temporaryPasswordUpdatedSuccess ?? j.status.temporaryPasswordUpdatedSuccess ?? "Temporary password updated successfully. Please log in with your new password."
        ), await new Promise((at) => setTimeout(at, 500)), await ye(), me());
      } catch (P) {
        G(!1), Bt(P) ? (Z(Ve(P, l)), v(null)) : (f("negative"), v(Ve(P, l)));
      } finally {
        L(!1);
      }
      return;
    }
    if (L(!0), v(null), f("informative"), c === "mfacode") {
      try {
        if ((await Fe({ challengeResponse: se })).nextStep.signInStep !== "DONE") {
          f("negative"), v(l.errors.unsupportedSignInStep);
          return;
        }
        await e();
      } catch {
        f("negative"), v(l.errors.invalidMfaCode);
      } finally {
        L(!1);
      }
      return;
    }
    if (await ye(), c === "sso") {
      if (!V) {
        f("negative"), v(l.errors.identityProviderUndefined), L(!1);
        return;
      }
      p !== "/" && qe(p), await $e({
        provider: { custom: V },
        customState: JSON.stringify({ isWebLogin: "true" })
      }), L(!1);
      return;
    }
    try {
      switch (ee(null), (await ut({
        username: m.trim().toLowerCase(),
        password: X,
        options: {
          clientMetadata: {
            isWebLogin: "true"
          }
        }
      })).nextStep.signInStep) {
        case "RESET_PASSWORD":
          f("negative"), v(l.errors.passwordResetRequired);
          break;
        case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
          z(!0);
          break;
        case "CONFIRM_SIGN_IN_WITH_TOTP_CODE":
          b("mfacode");
          break;
        case "DONE":
          await e();
          break;
        default:
          f("negative"), v(l.errors.unsupportedSignInStep);
      }
    } catch (P) {
      console.error(
        "[CustomLoginForm.handleSubmit]",
        JSON.stringify({
          message: P instanceof Error ? P.message : String(P),
          name: P instanceof Error ? P.name : void 0
        })
      ), f("negative"), Gt(P) ? (ee(l.errors.incorrectEmailOrPassword), v(null)) : v(Ue(P, l));
    } finally {
      L(!1);
    }
  }
  async function rt() {
    L(!0);
    try {
      await e();
    } finally {
      L(!1);
    }
  }
  const ot = typeof r == "function" ? r(m.trim().toLowerCase()) : r, st = $ ? l.accessibility.hidePassword : l.accessibility.showPassword, it = le ? l.accessibility.hidePassword : l.accessibility.showPassword, nt = R ? l.accessibility.hidePassword : l.accessibility.showPassword;
  return {
    authType: c,
    checkEmail: De,
    confirmPassword: N,
    confirmPasswordVisibilityLabel: nt,
    email: m,
    emailError: Q,
    firstSignIn: x,
    forgotPasswordUrl: ot,
    handleSubmit: tt,
    isAccountCreated: A,
    isCheckingEmail: ae,
    isConfirmPasswordVisible: R,
    isFormValid: y,
    isLoading: ue,
    isNewPasswordVisible: le,
    isPasswordVisible: $,
    isRememberMeEnabled: F,
    isSsoRedirecting: ce,
    isTemporaryPasswordChallenge: c === "temporaryPassword" && x,
    messages: l,
    mfaCode: se,
    newPassword: J,
    newPasswordError: he,
    newPasswordVisibilityLabel: it,
    passedPasswordHistory: we,
    password: X,
    passwordError: fe,
    passwordValidation: q,
    passwordVisibilityLabel: st,
    resetAuthState: me,
    setConfirmPassword: E,
    setEmail: C,
    setEmailError: K,
    setIsConfirmPasswordVisible: k,
    setIsNewPasswordVisible: re,
    setIsPasswordVisible: D,
    setIsRememberMeEnabled: oe,
    setMfaCode: de,
    setNewPassword: O,
    setNewPasswordError: Z,
    setPassedPasswordHistory: G,
    setPassword: B,
    setPasswordError: ee,
    setPasswordValidation: te,
    startMonitoring: rt,
    statusMessage: Ee,
    statusTone: I
  };
}
function Qt({
  authenticate: e,
  forgotPasswordHref: r,
  initialEmail: t = "",
  initialStatusMessage: s,
  isAuthenticated: n,
  lookupLoginMethod: a,
  messages: i,
  onNavigate: d,
  passwordUpdated: w = !1,
  redirectTo: g = "/",
  supportHref: l
}) {
  const {
    authType: p,
    checkEmail: c,
    confirmPassword: b,
    confirmPasswordVisibilityLabel: N,
    email: E,
    emailError: m,
    firstSignIn: C,
    forgotPasswordUrl: Q,
    handleSubmit: K,
    isAccountCreated: x,
    isCheckingEmail: z,
    isConfirmPasswordVisible: V,
    isFormValid: M,
    isLoading: A,
    isNewPasswordVisible: _,
    isPasswordVisible: ae,
    isRememberMeEnabled: H,
    isSsoRedirecting: ue,
    isTemporaryPasswordChallenge: L,
    messages: R,
    mfaCode: k,
    newPassword: le,
    newPasswordError: re,
    newPasswordVisibilityLabel: $,
    passedPasswordHistory: D,
    password: F,
    passwordError: oe,
    passwordValidation: ce,
    passwordVisibilityLabel: Y,
    resetAuthState: se,
    setConfirmPassword: de,
    setEmail: J,
    setEmailError: O,
    setIsConfirmPasswordVisible: he,
    setIsNewPasswordVisible: Z,
    setIsPasswordVisible: we,
    setIsRememberMeEnabled: G,
    setMfaCode: X,
    setNewPassword: B,
    setNewPasswordError: fe,
    setPassedPasswordHistory: ee,
    setPassword: q,
    setPasswordError: te,
    setPasswordValidation: I,
    startMonitoring: f,
    statusMessage: Ee,
    statusTone: v
  } = jt({
    authenticate: e,
    forgotPasswordHref: r,
    initialEmail: t,
    initialStatusMessage: s,
    isAuthenticated: n,
    lookupLoginMethod: a,
    messages: i,
    onNavigate: d,
    passwordUpdated: w,
    redirectTo: g,
    supportHref: l
  }), me = R.actions.reachOutToSupport ?? j.actions.reachOutToSupport;
  return /* @__PURE__ */ o("div", { className: "w-full bg-surface-low", children: /* @__PURE__ */ o(
    bt,
    {
      label: R.loading.ssoRedirecting ?? "",
      open: ue,
      children: /* @__PURE__ */ h("div", { className: "relative flex min-h-screen w-full flex-col items-stretch", children: [
        /* @__PURE__ */ o("header", { className: "flex h-(--spacing-64) w-full items-center border-b border-outline-subtle bg-surface px-(--spacing-16)", children: /* @__PURE__ */ o(
          ge,
          {
            "aria-label": R.accessibility.assetWatchLogoAriaLabel
          }
        ) }),
        /* @__PURE__ */ o("div", { className: "flex w-full flex-1 justify-center px-(--spacing-20) pt-(--spacing-40) pb-(--spacing-24) sm:pt-(--spacing-80) sm:pb-(--spacing-40)", children: /* @__PURE__ */ o(
          "form",
          {
            className: "w-full max-w-[480px]",
            "data-testid": "login-form",
            noValidate: !0,
            onSubmit: (y) => {
              y.preventDefault(), p === "" ? c() : (p === "sso" || M()) && K();
            },
            children: /* @__PURE__ */ o(S, { gap: 40, children: x ? /* @__PURE__ */ o(
              Nt,
              {
                isLoading: A,
                messages: R,
                onStartMonitoring: () => {
                  f();
                }
              }
            ) : /* @__PURE__ */ h(W, { children: [
              /* @__PURE__ */ o(
                _t,
                {
                  authType: p,
                  firstSignIn: C,
                  isTemporaryPasswordChallenge: L,
                  messages: R
                }
              ),
              Ee ? /* @__PURE__ */ o(je, { tone: v, title: Ee }) : null,
              /* @__PURE__ */ h(S, { gap: 16, children: [
                /* @__PURE__ */ o(
                  Ot,
                  {
                    authType: p,
                    email: E,
                    emailError: m,
                    isCheckingEmail: z,
                    isRememberMeEnabled: H,
                    messages: R,
                    onCheckEmail: () => {
                      c();
                    },
                    onEmailChange: (y) => {
                      J(y), O(null);
                    },
                    onRememberMeChange: G
                  }
                ),
                p === "temporaryPassword" && !C ? /* @__PURE__ */ o(
                  Dt,
                  {
                    canSubmit: M(),
                    email: E,
                    isLoading: A,
                    isPasswordVisible: ae,
                    messages: R,
                    onPasswordChange: (y) => {
                      q(y), te(null);
                    },
                    onPasswordVisibilityChange: () => we((y) => !y),
                    password: F,
                    passwordError: oe,
                    passwordVisibilityLabel: Y
                  }
                ) : null,
                p === "basic" ? C ? /* @__PURE__ */ o(
                  Vt,
                  {
                    messages: R,
                    password: F
                  }
                ) : /* @__PURE__ */ o(
                  Ft,
                  {
                    canSubmit: M(),
                    email: E,
                    forgotPasswordUrl: Q,
                    isLoading: A,
                    isPasswordVisible: ae,
                    messages: R,
                    onChangeEmail: () => se(),
                    onPasswordChange: (y) => {
                      q(y), te(null);
                    },
                    onPasswordVisibilityChange: () => we((y) => !y),
                    password: F,
                    passwordError: oe,
                    passwordVisibilityLabel: Y
                  }
                ) : null,
                C ? /* @__PURE__ */ o(
                  qt,
                  {
                    canSubmit: M(),
                    confirmPassword: b,
                    confirmPasswordVisibilityLabel: N,
                    isConfirmPasswordVisible: V,
                    isLoading: A,
                    isNewPasswordVisible: _,
                    isTemporaryPasswordChallenge: L,
                    messages: R,
                    newPassword: le,
                    newPasswordError: re,
                    newPasswordVisibilityLabel: $,
                    onConfirmPasswordChange: (y) => {
                      de(y), I((Pe) => ({
                        ...Pe,
                        matchesConfirm: y === le
                      }));
                    },
                    onConfirmPasswordVisibilityChange: () => he((y) => !y),
                    onNewPasswordChange: (y) => {
                      B(y), fe(null), I(
                        zt(y, b)
                      ), ee(
                        (Pe) => Pe === !1 ? !1 : void 0
                      );
                    },
                    onNewPasswordVisibilityChange: () => Z((y) => !y),
                    passedPasswordHistory: D,
                    passwordValidation: ce
                  }
                ) : null,
                p === "mfacode" ? /* @__PURE__ */ o(
                  Ut,
                  {
                    canSubmit: M(),
                    isLoading: A,
                    messages: R,
                    mfaCode: k,
                    onMfaCodeChange: X
                  }
                ) : null
              ] })
            ] }) })
          }
        ) }),
        l && !(p === "temporaryPassword" && !C || x) ? /* @__PURE__ */ o("footer", { className: "w-full px-(--spacing-20) pb-(--spacing-24) sm:pb-(--spacing-40)", children: /* @__PURE__ */ h(Ce, { gap: 0, justify: "center", children: [
          /* @__PURE__ */ o(U, { tone: "subtext", children: R.copy.supportQuestion }),
          /* @__PURE__ */ o(
            T,
            {
              children: me,
              icon: "arrow-up-right",
              render: /* @__PURE__ */ o("a", { href: l, "aria-label": me }),
              size: "sm",
              variant: "ghost"
            }
          )
        ] }) }) : null
      ] })
    }
  ) });
}
function Rr({
  children: e,
  loadingFallback: r,
  lookupLoginMethod: t,
  loginMessages: s,
  supportHref: n,
  renderAuthenticated: a
}) {
  const { isAuthenticated: i, isLoading: d, refreshAuth: w, user: g, validationError: l } = Ye(), p = gt({
    select: (c) => c.location.pathname + c.location.searchStr
  });
  return p.startsWith("/login/reset") ? /* @__PURE__ */ o(W, { children: e }) : d ? /* @__PURE__ */ o(W, { children: r }) : i ? /* @__PURE__ */ o(W, { children: a?.({ children: e, user: g }) ?? e }) : /* @__PURE__ */ o(
    Qt,
    {
      authenticate: w,
      forgotPasswordHref: (c) => `/login/reset?email=${encodeURIComponent(c)}`,
      initialStatusMessage: l ?? void 0,
      isAuthenticated: i,
      lookupLoginMethod: t,
      messages: s,
      onNavigate: (c) => {
        window.location.replace(c);
      },
      redirectTo: p,
      supportHref: n
    }
  );
}
function Xe(e) {
  return typeof Request < "u" && e instanceof Request;
}
function Kt(e, r) {
  const t = r?.method ?? (Xe(e) ? e.method : "GET"), s = typeof e == "string" ? e : e instanceof URL ? e.toString() : e.url;
  return { method: t.toUpperCase(), url: s };
}
function Yt(e, r) {
  const t = new Headers(Xe(e) ? e.headers : void 0);
  return r?.headers && new Headers(r.headers).forEach((s, n) => {
    t.set(n, s);
  }), t;
}
function Ne(e, r) {
  try {
    e?.(r);
  } catch {
  }
}
function Lr({
  createRequestId: e,
  getAdditionalHeaders: r,
  onBreadcrumb: t
}) {
  return async (s, n) => {
    const a = await ze(), i = a.tokens?.idToken?.toString() ?? a.tokens?.accessToken?.toString(), d = Yt(s, n), w = e(), { method: g, url: l } = Kt(s, n), p = Date.now();
    i && d.set("Authorization", `Bearer ${i}`), d.set("X-Request-Id", w), r && new Headers(r()).forEach((c, b) => {
      d.set(b, c);
    }), Ne(t, { phase: "request", method: g, url: l, requestId: w });
    try {
      const c = await fetch(s, { ...n, headers: d });
      return Ne(t, {
        phase: "response",
        method: g,
        url: l,
        requestId: w,
        statusCode: c.status,
        durationMs: Date.now() - p
      }), c;
    } catch (c) {
      throw Ne(t, {
        phase: "error",
        method: g,
        url: l,
        requestId: w,
        durationMs: Date.now() - p,
        errorName: c instanceof Error ? c.name : "UnknownError"
      }), c;
    }
  };
}
function Jt(e) {
  return e.authType === "sso" || e.authorize_href && e.identityProvider ? e.identityProvider ? {
    authType: "sso",
    identityProvider: e.identityProvider
  } : { authType: "basic" } : e.authType === "temporaryPassword" || e.requiresTempPassword || e.userStatus === "FORCE_CHANGE_PASSWORD" || e.status === "FORCE_CHANGE_PASSWORD" ? { authType: "temporaryPassword" } : { authType: "basic" };
}
function xr(e) {
  return async (r) => {
    if (!e)
      return { authType: "basic" };
    const t = await fetch(`${e}/user/usertype`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ user_email: r })
    });
    if (t.status === 404)
      return { authType: "basic" };
    if (!t.ok)
      throw new Error(`Auth lookup failed with ${t.status}`);
    return Jt(
      await t.json()
    );
  };
}
const Oe = He({
  isReady: !0
});
function Zt({
  children: e,
  context: r,
  isReadyToIdentify: t
}) {
  const s = vt(), [n, a] = u(null), i = JSON.stringify(r);
  return be(() => {
    if (!s) {
      a(null);
      return;
    }
    if (!t) {
      a(null);
      return;
    }
    let d = !1;
    return a(null), Promise.resolve(s.identify(JSON.parse(i))).catch(() => {
    }).finally(() => {
      d || a(i);
    }), () => {
      d = !0;
    };
  }, [i, t, s]), /* @__PURE__ */ o(
    Oe.Provider,
    {
      value: {
        isReady: t && n === i
      },
      children: e
    }
  );
}
function Tr() {
  return Ge(Oe);
}
function Nr({
  children: e,
  clientSideID: r,
  getContext: t = ({ user: n }) => ({
    kind: "user",
    key: n?.sub ?? "anonymous",
    email: n?.email ?? "",
    role: n?.role ?? "",
    roles: n?.roles ?? [],
    cognitoGroups: n?.cognitoGroups ?? []
  }),
  isReadyToIdentify: s = ({ isAuthenticated: n, isLoading: a, user: i }) => !a && n && !!i?.sub && !!i?.email
}) {
  const n = Ye();
  if (!r)
    return /* @__PURE__ */ o(Oe.Provider, { value: { isReady: !0 }, children: e });
  const a = t(n);
  return /* @__PURE__ */ o(St, { clientSideID: r, context: {
    kind: "user",
    key: "anonymous",
    anonymous: !0
  }, children: /* @__PURE__ */ o(
    Zt,
    {
      context: a,
      isReadyToIdentify: s(n),
      children: e
    }
  ) });
}
const We = {
  prod: {
    USER_POOL_ID: "us-east-2_MqZrrppS1",
    APP_CLIENT_ID: "7phcejhgai3vf6rj7mr526akc",
    IDENTITY_POOL_ID: "us-east-2:9ea0609d-9c44-4356-ae9e-6d38aa1898a1",
    DOMAIN: "auth-idp.assetwatch.com"
  },
  qa: {
    USER_POOL_ID: "us-east-2_tGB8JmQO3",
    APP_CLIENT_ID: "30ajgh20k1njb80coevmf9v1kr",
    IDENTITY_POOL_ID: "us-east-2:e6134d6f-3cbb-4c0f-a61a-7e1e184a4e59",
    DOMAIN: "auth-idp.qa.qa.assetwatch.com"
  },
  dev: {
    USER_POOL_ID: "us-east-2_x7NmjJEZB",
    APP_CLIENT_ID: "3urf9oqfossk0dv7eacrkl4p4h",
    IDENTITY_POOL_ID: "us-east-2:f2b106f4-7e58-4fe5-9576-59bfdd75cfe0",
    DOMAIN: "auth-idp.dev.dev.assetwatch.com"
  }
}, Xt = [
  "USER_POOL_ID",
  "APP_CLIENT_ID",
  "IDENTITY_POOL_ID",
  "DOMAIN"
];
function kr({
  allowFallback: e = !1,
  deployEnvironment: r,
  injectedConfig: t
}) {
  const s = Xt.map((i) => [i, t?.[i]]), n = s.filter(([, i]) => !i).map(([i]) => `VITE_COGNITO_${i}`);
  if (t && n.length !== s.length) {
    if (n.length > 0)
      throw new Error(
        `Incomplete Cognito config. Missing: ${n.join(", ")}`
      );
    return t;
  }
  if (!e)
    throw new Error(
      `Cognito config is required. Missing: ${n.join(", ")}`
    );
  return We[r] ?? We.dev;
}
const _e = "NikolaTeam";
function er(e) {
  if (!e?.trim())
    return !1;
  const r = e.trim();
  return r === _e ? !0 : r.split(/[,;]/).map((t) => t.trim()).some((t) => t === _e);
}
function $r(e) {
  return e ? er(e.role) ? !0 : e.cognitoGroups.includes(_e) : !1;
}
function tr(e) {
  if (e === "prod" || e === "qa-legacy") return ".assetwatch.com";
  const { hostname: r } = window.location, t = r.split(".");
  if (t.length >= 5) return "." + t.slice(1).join(".");
  if (t.length === 4) return "." + r;
}
function Mr(e) {
  It.setKeyValueStorage(
    new Et({
      domain: tr(e),
      secure: window.location.protocol === "https:",
      sameSite: "lax",
      expires: 30
    })
  );
}
function et(e, r) {
  return {
    digitRequirement: e(
      `${r}.auth.passwordRequirements.digitRequirement`
    ),
    lowercaseRequirement: e(
      `${r}.auth.passwordRequirements.lowercaseRequirement`
    ),
    uppercaseRequirement: e(
      `${r}.auth.passwordRequirements.uppercaseRequirement`
    ),
    specialCharacterRequirement: e(
      `${r}.auth.passwordRequirements.specialCharacterRequirement`
    ),
    lengthRequirement: e(
      `${r}.auth.passwordRequirements.lengthRequirement`
    ),
    previousPasswordRequirement: e(
      `${r}.auth.passwordRequirements.previousPasswordRequirement`
    ),
    passwordStrength: {
      weak: e(`${r}.auth.passwordRequirements.passwordStrength.weak`),
      fair: e(`${r}.auth.passwordRequirements.passwordStrength.fair`),
      strong: e(
        `${r}.auth.passwordRequirements.passwordStrength.strong`
      )
    }
  };
}
function Ar(e, { commonNamespace: r, namespace: t }) {
  return {
    accessibility: {
      assetWatchLogoAriaLabel: e(`${r}.assetWatchLabel`),
      hidePassword: e(`${t}.auth.signIn.hidePassword`),
      showPassword: e(`${t}.auth.signIn.showPassword`)
    },
    headings: {
      signInTitle: e(`${t}.auth.signIn.title`),
      signInDescription: e(`${t}.auth.signIn.description`),
      updatePasswordTitle: e(`${t}.auth.signIn.updatePasswordTitle`),
      updatePasswordDescription: e(
        `${t}.auth.signIn.updatePasswordDescription`
      ),
      accountCreatedTitle: e(`${t}.auth.signIn.accountCreatedTitle`),
      accountCreatedDescription: e(
        `${t}.auth.signIn.accountCreatedDescription`
      ),
      twoFactorTitle: e(`${t}.auth.signIn.twoFactorTitle`),
      twoFactorDescription: e(`${t}.auth.signIn.twoFactorDescription`)
    },
    labels: {
      email: e(`${t}.auth.signIn.emailLabel`),
      password: e(`${t}.auth.signIn.passwordLabel`),
      newPassword: e(`${t}.auth.signIn.newPasswordLabel`),
      confirmPassword: e(`${t}.auth.signIn.confirmPasswordLabel`),
      verificationCode: e(`${t}.auth.signIn.verificationCodeLabel`)
    },
    placeholders: {
      email: e(`${t}.auth.signIn.emailPlaceholder`)
    },
    actions: {
      rememberMe: e(`${t}.auth.signIn.rememberMe`),
      continue: e(`${t}.auth.signIn.continue`),
      forgotPassword: e(`${t}.auth.signIn.forgotPassword`),
      reachOutToSupport: e(`${t}.auth.signIn.reachOutToSupport`),
      login: e(`${t}.auth.signIn.login`),
      loginWithSso: e(`${t}.auth.signIn.loginWithSso`),
      retry: e(`${t}.auth.signIn.retry`),
      saveChanges: e(`${t}.auth.signIn.saveChanges`),
      startMonitoring: e(`${t}.auth.signIn.startMonitoring`),
      setNewPassword: e(`${t}.auth.signIn.setNewPassword`),
      changeEmail: e(`${t}.auth.signIn.changeEmail`),
      submit: e(`${t}.auth.signIn.submit`)
    },
    loading: {
      checking: e(`${t}.auth.signIn.loading.checking`),
      updatingPassword: e(`${t}.auth.signIn.loading.updatingPassword`),
      loggingIn: e(`${t}.auth.signIn.loading.loggingIn`),
      verifying: e(`${t}.auth.signIn.loading.verifying`),
      redirecting: e(`${t}.auth.signIn.loading.redirecting`),
      ssoRedirecting: e(`${t}.auth.signIn.loading.ssoRedirecting`)
    },
    copy: {
      newPasswordPrompt: e(`${t}.auth.signIn.newPasswordPrompt`),
      passwordRequirementsHeading: e(
        `${t}.auth.signIn.passwordRequirementsHeading`
      ),
      temporaryPasswordPrompt: e(
        `${t}.auth.signIn.temporaryPasswordPrompt`
      ),
      temporaryPasswordHelp: e(
        `${t}.auth.signIn.temporaryPasswordHelp`
      ),
      confirmPasswordMismatch: e(
        `${t}.auth.signIn.confirmPasswordMismatch`
      ),
      supportQuestion: e(`${t}.auth.signIn.supportQuestion`)
    },
    status: {
      passwordUpdatedSuccess: e(
        `${t}.auth.signIn.status.passwordUpdated`
      ),
      temporaryPasswordUpdatedSuccess: e(
        `${t}.auth.signIn.status.temporaryPasswordUpdated`
      )
    },
    errors: {
      invalidEmail: e(`${t}.auth.signIn.errors.invalidEmail`),
      incorrectEmailOrPassword: e(
        `${t}.auth.signIn.errors.incorrectEmailOrPassword`
      ),
      accountNotConfirmed: e(
        `${t}.auth.signIn.errors.accountNotConfirmed`
      ),
      passwordResetRequired: e(
        `${t}.auth.signIn.errors.passwordResetRequired`
      ),
      tooManyAttempts: e(`${t}.auth.signIn.errors.tooManyAttempts`),
      network: e(`${t}.auth.signIn.errors.network`),
      generic: e(`${t}.auth.signIn.errors.generic`),
      passwordHistoryViolation: e(
        `${t}.auth.signIn.errors.passwordHistoryViolation`
      ),
      invalidPasswordPolicy: e(`${t}.auth.signIn.errors.invalidPasswordPolicy`) || j.errors.invalidPasswordPolicy,
      updatePasswordGeneric: e(`${t}.auth.signIn.errors.updatePasswordGeneric`) || j.errors.updatePasswordGeneric,
      invalidMfaCode: e(`${t}.auth.signIn.errors.invalidMfaCode`),
      identityProviderUndefined: e(
        `${t}.auth.signIn.errors.identityProviderUndefined`
      ),
      unsupportedSignInStep: e(
        `${t}.auth.signIn.errors.unsupportedSignInStep`
      )
    },
    passwordRequirements: et(e, t)
  };
}
function _r(e, { commonNamespace: r, namespace: t }) {
  return {
    assetWatchLabel: e(`${r}.assetWatchLabel`),
    backToSignIn: e(`${t}.auth.passwordReset.backToSignIn`),
    confirmNewPasswordLabel: e(
      `${t}.auth.passwordReset.confirmPasswordLabel`
    ),
    continueToSignIn: e(`${t}.auth.passwordReset.continueToSignIn`),
    description: e(`${t}.auth.passwordReset.description`),
    emailLabel: e(`${t}.auth.passwordReset.emailLabel`),
    emailPlaceholder: e(`${t}.auth.passwordReset.emailPlaceholder`),
    emailSentMessage: e(`${t}.auth.passwordReset.emailSentMessage`),
    emailSentTitle: e(`${t}.auth.passwordReset.emailSentTitle`),
    expiredLinkDescription: e(
      `${t}.auth.passwordReset.expiredLinkDescription`
    ),
    expiredLinkTitle: e(`${t}.auth.passwordReset.expiredLinkTitle`),
    forgotPasswordDescription: e(
      `${t}.auth.passwordReset.forgotPasswordDescription`
    ),
    forgotPasswordTitle: e(
      `${t}.auth.passwordReset.forgotPasswordTitle`
    ),
    hidePassword: e(`${t}.auth.signIn.hidePassword`),
    loadingSendingCode: e(
      `${t}.auth.passwordReset.loading.sendingCode`
    ),
    loadingUpdatingPassword: e(
      `${t}.auth.passwordReset.loading.updatingPassword`
    ),
    newPasswordLabel: e(`${t}.auth.passwordReset.newPasswordLabel`),
    passwordRequirementsIntro: e(
      `${t}.auth.passwordReset.passwordRequirementsIntro`
    ),
    passwordSavedMessage: e(
      `${t}.auth.passwordReset.passwordSavedMessage`
    ),
    passwordSavedTitle: e(`${t}.auth.passwordReset.passwordSavedTitle`),
    passwordsDoNotMatch: e(
      `${t}.auth.passwordReset.passwordsDoNotMatch`
    ),
    reachOutToSupport: e(`${t}.auth.signIn.reachOutToSupport`),
    resetCodeLabel: e(`${t}.auth.passwordReset.resetCodeLabel`),
    saveChanges: e(`${t}.auth.passwordReset.saveChanges`),
    sendNewLink: e(`${t}.auth.passwordReset.sendNewLink`),
    sendResetCode: e(`${t}.auth.passwordReset.sendResetCode`),
    showPassword: e(`${t}.auth.signIn.showPassword`),
    supportQuestion: e(`${t}.auth.signIn.supportQuestion`),
    title: e(`${t}.auth.passwordReset.title`),
    errors: {
      codeMismatch: e(`${t}.auth.passwordReset.errors.codeMismatch`),
      expiredCode: e(`${t}.auth.passwordReset.errors.expiredCode`),
      generic: e(`${t}.auth.passwordReset.errors.generic`),
      invalidPassword: e(
        `${t}.auth.passwordReset.errors.invalidPassword`
      ),
      limitExceeded: e(`${t}.auth.passwordReset.errors.limitExceeded`),
      passwordHistoryViolation: e(
        `${t}.auth.passwordReset.errors.passwordHistoryViolation`
      ),
      unverifiedContact: e(
        `${t}.auth.passwordReset.errors.unverifiedContact`
      ),
      userNotFound: e(`${t}.auth.passwordReset.errors.userNotFound`)
    },
    passwordRequirements: et(e, t) ?? Se
  };
}
function Or({
  apiName: e = "apiVeroUser",
  notProvisionedMessage: r = (t) => `User ${t} not found. Please contact support.`
} = {}) {
  return async ({ user: t }) => {
    const { body: s } = await Rt({
      apiName: e,
      path: "/list",
      options: {
        body: {
          meth: "getCurrentUserInfo"
        }
      }
    }).response;
    return (await s.json()).email ? { ok: !0 } : {
      ok: !1,
      message: r(t.sub)
    };
  };
}
function rr(e, r) {
  return {
    hasUppercase: e.toLowerCase() !== e,
    hasLowercase: e.toUpperCase() !== e,
    hasNumber: /[0-9]/.test(e),
    hasSpecialCharacter: /[^a-zA-Z0-9]/.test(e),
    hasSufficientLength: e.length >= 10 && e.length <= 32,
    matchesConfirm: e === r
  };
}
function or(e) {
  return e.hasUppercase && e.hasLowercase && e.hasNumber && e.hasSpecialCharacter && e.hasSufficientLength && e.matchesConfirm;
}
function ve(e) {
  return typeof e == "object" && e !== null;
}
function Le(e, r) {
  const t = e[r];
  return typeof t == "string" ? t : void 0;
}
function Ie(e) {
  return Le(e, "name") ?? Le(e, "code") ?? Le(e, "__type")?.split("#").pop() ?? "";
}
function ke(e, r) {
  if (!ve(e))
    return r.errors.generic;
  const t = Ie(e), s = Le(e, "message") ?? "";
  return t === "InvalidPasswordException" ? r.errors.invalidPassword : t === "InvalidParameterException" && s.includes("no registered/verified email") ? r.errors.unverifiedContact : {
    CodeMismatchException: r.errors.codeMismatch,
    ExpiredCodeException: r.errors.expiredCode,
    LimitExceededException: r.errors.limitExceeded,
    TooManyRequestsException: r.errors.limitExceeded,
    UserNotFoundException: r.errors.userNotFound
  }[t] ?? (s || r.errors.generic);
}
function sr(e) {
  return ve(e) && Ie(e) === "ExpiredCodeException";
}
function ir(e) {
  return ve(e) && Ie(e) === "CodeMismatchException";
}
function nr(e) {
  if (!ve(e))
    return !1;
  const r = Ie(e);
  return r === "PasswordHistoryPolicyViolationException" || r === "InvalidPasswordException";
}
function ar(e, r) {
  return ve(e) && Ie(e) === "PasswordHistoryPolicyViolationException" ? r.errors.passwordHistoryViolation : r.errors.invalidPassword;
}
function lr({
  canSendCode: e,
  email: r,
  isSendingCode: t,
  messages: s,
  onEmailChange: n,
  onSubmit: a
}) {
  return /* @__PURE__ */ o("form", { onSubmit: a, children: /* @__PURE__ */ h(S, { gap: 40, children: [
    /* @__PURE__ */ o(
      ne,
      {
        autoComplete: "email",
        label: s.emailLabel,
        onChange: n,
        placeholder: s.emailPlaceholder,
        type: "email",
        value: r
      }
    ),
    /* @__PURE__ */ o(
      T,
      {
        disabled: !e,
        fullWidth: !0,
        loading: t,
        loadingText: s.loadingSendingCode,
        type: "submit",
        children: s.sendResetCode
      }
    )
  ] }) });
}
function dr({
  canConfirm: e,
  confirmPassword: r,
  isConfirming: t,
  messages: s,
  newPassword: n,
  newPasswordError: a,
  onConfirmPasswordChange: i,
  onNewPasswordChange: d,
  onResetCodeChange: w,
  onSubmit: g,
  passwordValidation: l,
  resetCode: p,
  showResetCodeInput: c
}) {
  const [b, N] = u(!1), [E, m] = u(!1);
  return /* @__PURE__ */ o("form", { onSubmit: g, children: /* @__PURE__ */ h(S, { gap: 40, children: [
    /* @__PURE__ */ h(S, { gap: 16, children: [
      c ? /* @__PURE__ */ o(
        ne,
        {
          autoComplete: "one-time-code",
          label: s.resetCodeLabel,
          onChange: w,
          value: p
        }
      ) : null,
      /* @__PURE__ */ o(
        ne,
        {
          autoComplete: "new-password",
          error: a ?? void 0,
          label: s.newPasswordLabel,
          onChange: d,
          trailingAction: {
            icon: b ? "eye-watching" : "eye-slash-regular",
            "aria-label": b ? s.hidePassword : s.showPassword,
            "aria-pressed": b,
            onClick: () => N((C) => !C)
          },
          type: b ? "text" : "password",
          value: n
        }
      ),
      /* @__PURE__ */ o(
        Je,
        {
          labels: s.passwordRequirements ?? Se,
          requirements: l,
          showPreviousPasswordRequirement: !1,
          title: s.passwordRequirementsIntro,
          variant: "panel"
        }
      ),
      /* @__PURE__ */ o(
        ne,
        {
          autoComplete: "new-password",
          error: r.length > 0 && !l.matchesConfirm ? s.passwordsDoNotMatch : void 0,
          label: s.confirmNewPasswordLabel,
          onChange: i,
          trailingAction: {
            icon: E ? "eye-watching" : "eye-slash-regular",
            "aria-label": E ? s.hidePassword : s.showPassword,
            "aria-pressed": E,
            onClick: () => m((C) => !C)
          },
          type: E ? "text" : "password",
          value: r
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        disabled: !e,
        fullWidth: !0,
        loading: t,
        loadingText: s.loadingUpdatingPassword,
        type: "submit",
        children: s.saveChanges
      }
    )
  ] }) });
}
function Dr({
  confirmPasswordReset: e,
  initialCode: r = "",
  initialEmail: t = "",
  initialExpired: s = !1,
  isConfirming: n,
  isSendingCode: a,
  messages: i,
  onNavigateToSignIn: d,
  sendPasswordResetCode: w,
  supportHref: g = "mailto:support@assetwatch.com"
}) {
  const [l, p] = u(t), [c, b] = u(r), [N, E] = u(""), [m, C] = u(null), [Q, K] = u(""), [x, z] = u(!1), [V, M] = u(!!r && !!t), [A, _] = u(!!s && !!t), [ae] = u(
    !!r && !!t
  ), [H, ue] = u(s), [L, R] = u(!1), [k, le] = u(!1), [re, $] = u(null), D = l.trim().toLowerCase(), F = c.trim().length > 0, oe = D.length > 0 && !a, ce = rr(N, Q), Y = D.length > 0 && F && or(ce) && !n;
  async function se(I) {
    if (I?.preventDefault(), !!oe) {
      $(null);
      try {
        if (he) {
          M(!0);
          return;
        }
        if (Z) {
          _(!0);
          return;
        }
        await w(D), z(!0), ue(!1), R(!1), _(!1), b(""), $(null);
      } catch (f) {
        $({
          tone: "negative",
          message: ke(f, i)
        });
      }
    }
  }
  async function de(I) {
    if (I.preventDefault(), !!Y) {
      $(null), C(null);
      try {
        await e({
          username: D,
          confirmationCode: c.trim(),
          newPassword: N
        }), le(!0), $(null);
      } catch (f) {
        sr(f) ? (ue(!0), _(D.length > 0), $(null)) : ir(f) ? (R(!0), $({
          tone: "negative",
          message: ke(f, i)
        })) : nr(f) ? (C(ar(f, i)), $(null)) : $({
          tone: "negative",
          message: ke(f, i)
        });
      }
    }
  }
  const J = !k && x && !H, O = !k && H, he = !k && !x && F && !V && !H, Z = O && !A, we = F && (ae || V), G = O && A, X = !k && !x && !ae && !F && !H, B = X || he || Z, fe = x || !F || L, ee = !k && !H && D.length > 0 && (x || we), q = k ? i.passwordSavedTitle : J ? i.emailSentTitle : O ? i.expiredLinkTitle : X ? i.forgotPasswordTitle : i.title, te = X || O;
  return /* @__PURE__ */ o("main", { className: "min-h-screen bg-surface-container-lowest", children: /* @__PURE__ */ h("div", { className: "flex min-h-screen flex-col", children: [
    /* @__PURE__ */ o("div", { className: "flex min-h-[64px] items-center bg-surface-container-lowest px-(--spacing-16)", children: /* @__PURE__ */ o(ge, { "aria-label": i.assetWatchLabel }) }),
    /* @__PURE__ */ o(Ct, { "aria-hidden": !0, variant: "full-width" }),
    /* @__PURE__ */ h("div", { className: "flex flex-1 flex-col items-center justify-between px-(--spacing-20)", children: [
      /* @__PURE__ */ o("div", { className: "flex w-full justify-center pt-(--spacing-40) md:pt-(--spacing-80)", children: /* @__PURE__ */ o("div", { className: "w-full max-w-[480px]", children: /* @__PURE__ */ h(S, { gap: 40, fullWidth: !0, children: [
        /* @__PURE__ */ h(S, { align: "center", gap: 16, fullWidth: !0, children: [
          /* @__PURE__ */ o("div", { className: "[&_svg]:h-auto [&_svg]:w-[90px]", children: /* @__PURE__ */ o(ge, { "aria-hidden": !0, tone: "default" }) }),
          /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: q }),
          /* @__PURE__ */ o("div", { className: J ? "w-full" : "max-w-[334px]", children: /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: k ? i.passwordSavedMessage : J ? /* @__PURE__ */ h(W, { children: [
            i.emailSentMessage,
            /* @__PURE__ */ o("br", {}),
            /* @__PURE__ */ o("span", { className: "font-(number:--font-weight-semibold) text-text-default", children: D })
          ] }) : O ? i.expiredLinkDescription : B ? i.forgotPasswordDescription : i.description }) })
        ] }),
        re && !k ? /* @__PURE__ */ o(je, { tone: re.tone, title: re.message }) : null,
        k ? /* @__PURE__ */ o(T, { fullWidth: !0, type: "button", onClick: d, children: i.continueToSignIn }) : /* @__PURE__ */ h(S, { gap: 24, children: [
          O && !B ? /* @__PURE__ */ h(W, { children: [
            /* @__PURE__ */ o(
              T,
              {
                disabled: !G,
                fullWidth: !0,
                loading: a,
                loadingText: i.loadingSendingCode,
                type: "button",
                onClick: () => {
                  se();
                },
                children: i.sendNewLink
              }
            ),
            /* @__PURE__ */ o(
              T,
              {
                type: "button",
                variant: "ghost",
                onClick: d,
                children: i.backToSignIn
              }
            )
          ] }) : null,
          B ? /* @__PURE__ */ o(
            lr,
            {
              canSendCode: oe,
              email: l,
              isSendingCode: a,
              messages: i,
              onEmailChange: (I) => p(I.currentTarget.value),
              onSubmit: (I) => {
                se(I);
              }
            }
          ) : null,
          ee ? /* @__PURE__ */ o(
            dr,
            {
              canConfirm: Y,
              confirmPassword: Q,
              isConfirming: n,
              messages: i,
              newPassword: N,
              newPasswordError: m,
              onConfirmPasswordChange: (I) => K(I.currentTarget.value),
              onNewPasswordChange: (I) => {
                E(I.currentTarget.value), C(null);
              },
              onResetCodeChange: (I) => b(I.currentTarget.value),
              onSubmit: (I) => {
                de(I);
              },
              passwordValidation: ce,
              resetCode: c,
              showResetCodeInput: fe
            }
          ) : null
        ] })
      ] }) }) }),
      te ? /* @__PURE__ */ o("div", { className: "w-full py-(--spacing-40)", children: /* @__PURE__ */ h(Ce, { gap: 0, justify: "center", children: [
        /* @__PURE__ */ o(U, { as: "span", tone: "subtext", children: i.supportQuestion }),
        /* @__PURE__ */ o(
          T,
          {
            render: /* @__PURE__ */ h(
              "a",
              {
                "aria-label": i.reachOutToSupport,
                href: g,
                children: [
                  i.reachOutToSupport,
                  /* @__PURE__ */ o(
                    Me,
                    {
                      "aria-hidden": !0,
                      name: "arrow-up-right",
                      size: "sm",
                      tone: "inherit"
                    }
                  )
                ]
              }
            ),
            size: "sm",
            variant: "ghost",
            children: i.reachOutToSupport
          }
        )
      ] }) }) : null
    ] })
  ] }) });
}
function Fr(e) {
  return Qe({
    mutationFn: ({ username: r }) => ht({ username: r }),
    ...e
  });
}
function qr(e) {
  return Qe({
    mutationFn: ({
      confirmationCode: r,
      newPassword: t,
      username: s
    }) => ct({
      username: s,
      confirmationCode: r,
      newPassword: t
    }),
    ...e
  });
}
const ur = [
  "Engineering"
], cr = "Engineering";
function hr(e) {
  return e.flatMap((r) => r?.split(/[,;]/) ?? []).map((r) => r.trim()).filter(Boolean);
}
function wr(e, r = ur) {
  if (!e)
    return !1;
  const t = new Set(r);
  return hr([
    e.role,
    ...e.roles ?? [],
    ...e.cognitoGroups ?? []
  ]).some((s) => t.has(s));
}
function Ur(e) {
  return wr(e, [cr]);
}
export {
  Nr as AuthLaunchDarklyProvider,
  Er as AuthProvider,
  Rr as AuthenticatedAppGate,
  _e as COGNITO_GROUP_NIKOLA_TEAM,
  Qt as CustomLoginForm,
  j as DEFAULT_CUSTOM_LOGIN_FORM_MESSAGES,
  ur as DEFAULT_RELEASE_INFO_ROLES,
  cr as ENGINEERING_ROLE,
  Je as PasswordRequirements,
  Dr as ResetPasswordPage,
  Ar as buildAuthCustomLoginFormMessages,
  et as buildAuthPasswordRequirementLabels,
  _r as buildAuthResetPasswordPageMessages,
  Mr as configureSharedCookieAuth,
  Lr as createAuthenticatedFetch,
  Or as createCurrentUserProvisionValidator,
  xr as createLoginMethodLookup,
  Ur as isEngineeringUser,
  er as isNikolaTeamCognitoGroup,
  $r as isNikolaTeamMember,
  wr as isReleaseInfoUser,
  Jt as mapLoginLookupResponse,
  kr as resolveAssetWatchCognitoConfig,
  xt as signOutEverywhere,
  Ye as useAuth,
  qr as useConfirmPasswordResetMutation,
  Tr as useLaunchDarklyStatus,
  Fr as useSendPasswordResetCodeMutation
};
